import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LastUsedEntry {
  modelId: string;
  timestamp: number;
}

interface LastUsedModelState {
  image: LastUsedEntry | null;
  video: LastUsedEntry | null;
  text: LastUsedEntry | null;
  setLastUsed: (mediaType: 'image' | 'video' | 'text', modelId: string) => void;
}

export const useLastUsedModelStore = create<LastUsedModelState>()(
  persist(
    (set) => ({
      image: null,
      video: null,
      text: null,
      setLastUsed: (mediaType, modelId) =>
        set({ [mediaType]: { modelId, timestamp: Date.now() } }),
    }),
    { name: 'cascady-last-used-model' }
  )
);
